<template>
  <div class="flex items-center gap-2 sm:gap-4 w-full justify-between">
    <div class="flex items-center gap-2 sm:gap-4">
      <div :class="step >= 3 ? 'activeInstitution' : 'inActiveInstitution'">
        <v-hand-heart-outline></v-hand-heart-outline>
      </div>
      <div :class="step >= 3 ? 'text-pdsPrimaryColor' : 'text-gray-300'" class="font-bold text-xl leading-snug">
        Rol & behandelgebieden
      </div>
    </div>
    <div v-if="step > 3" class="cursor-pointer text-pdsPrimaryColor text-sm font-semibold" @click="editRoleDetails">
      Wijzigen
    </div>
  </div>
  <div v-if="step == 3">
    <div class="mt-4 mb-2 flex flex-wrap gap-2" v-if="details.treatmentAreas.some((ta) => ta.active)">
      <label class="font-bold text-lg leading-6 text-gray-700"> Behandelgebied(en): </label>
      <div class="flex flex-wrap gap-2">
        <button
          v-for="item in details.treatmentAreas?.filter((r) => r.active)"
          :key="item.treatmentArea"
          class="flex items-center gap-2 px-3 py-1 text-sm font-medium bg-blue-100 text-blue-700 rounded-full"
        >
          <span>{{ item.treatmentArea }}</span>

          <!-- Close Icon -->
          <XMarkIcon
            class="h-4 w-4 cursor-pointer shrink-0 hover:text-red-500"
            @click.stop="deleteTreatmentArea(item)"
          />
        </button>
      </div>
    </div>
    <div class="mt-2 flex flex-col">
      <label class="font-bold text-base leading-6 text-cyan-900">Voor welke behandelgebieden schrijft u voor?*</label>
      <combo-boxes
        placeholder="Kies behandelgebied"
        :customClass="[
          'text-base leading-6 text-cyan-900 ',
          disableTreatmentArea ? 'bg-gray-300 cursor-none' : 'bg-white'
        ]"
        :disabledInput="'true'"
        v-model="selectedtreatmentArea"
        @update:model-value="saveTreatmentArea($event)"
        :list="treatmentAreaList"
        :rules="{
          required: true
        }"
        :disabled="disableTreatmentArea"
      >
      </combo-boxes>
      <div>
        <label class="font-bold text-base leading-6 text-cyan-900">Rol* </label>
        <combo-boxes
          customClass="text-base leading-6 text-cyan-900"
          placeholder="Kies een rol"
          v-model="selectedProfession"
          :list="professionList"
          :disabledInput="'true'"
          :rules="{
            required: true
          }"
        >
        </combo-boxes>
      </div>
    </div>
  </div>

  <div v-if="step > 3" class="mt-2 text-gray-700 text-sm sm:text-base break-words whitespace-normal">
    <div v-if="selectedtreatmentArea.data" class="font-bold text-sm leading-6 text-cyan-900 mt-4">
      Behandelgebied(en):
      <span class="font-semibold text-sm">
        {{
          details?.treatmentAreas
            ?.filter((a) => a.active)
            .map((a) => a.treatmentArea)
            .join(' , ')
        }}
      </span>
    </div>
    <div v-if="selectedProfession" class="font-bold text-sm leading-6 text-cyan-900">
      Rol:
      <span class="font-semibold text-sm">{{ selectedProfession.data }} </span>
    </div>
  </div>
  <div v-if="step >= 3" class="pt-2">
    <button
      :class="{
        'text-center text-white px-5 py-3 rounded-full border bg-gray-300 border-gray-300 cursor-default': !disableSave,
        'text-center text-white cursor-pointer bg-pdsPrimaryColor px-5 py-3 rounded-full border border-pdsPrimaryColor':
          disableSave
      }"
      @click.once.prevent="saveProfessionDetails"
    >
      Registratie voltooien
    </button>
  </div>
</template>

<script>
import { ref, onMounted, computed, watch } from 'vue';
import VHandHeartOutline from 'icons/HandHeartOutline';
import { useStore } from 'vuex';
import axios from 'axios';
import { XMarkIcon } from '@heroicons/vue/20/solid';
export default {
  name: 'AccountRegistrationRoleDetail',
  components: { VHandHeartOutline, XMarkIcon },
  props: {
    details: {
      type: Object,
      required: true
    },
    step: { type: Number, default: 0 }
  },
  emits: ['setRoleDetails'],
  setup(props, { emit }) {
    const store = useStore();
    const selectedtreatmentArea = ref({ id: '', data: '' });
    const selectedProfession = ref({ id: '', data: '' });
    const treatmentAreaList = ref([]);
    const professionList = ref([]);
    const disableTreatmentArea = ref(false);
    const isThuisServiceSelected = ref(false);
    const setProfession = (value) => store.commit('accountRegistration/setProfession', value);
    const setPrescriberTreatmentArea = (value) => store.commit('accountRegistration/setPrescriberTreatmentArea', value);
    const resetPrescriberTreatmentArea = (value) =>
      store.commit('accountRegistration/clearPrescriberTreatmentAreas', value);
    const disableSave = computed(() => {
      if (selectedProfession.value?.id && selectedtreatmentArea?.value.id) {
        return true;
      } else {
        return false;
      }
    });

    const getTreatmentAreaList = () => {
      if (props.details && props.details.treatmentAreas) {
        let treatmentAreas = props.details.treatmentAreas;
        treatmentAreas.map((element, item) => {
          treatmentAreaList.value.push({ id: element.treatmentAreaId, data: element.treatmentArea });
        });
      }
    };

    const getProfessions = async () => {
      return await axios.get('Registration/GetProfessions').then((response) => {
        response.data.map((element, item) => {
          professionList.value.push({ id: element.professionId, data: element.professionName });
        });
      });
    };
    function saveProfessionDetails() {
      if (selectedProfession.value) {
        setProfession(selectedProfession.value.id);
        emit('setRoleDetails', 4);
      }
    }
    const checkHuisartsenpraktijkTreatmentArea = () => {
      return props.details?.treatmentAreas.some((r) => r.treatmentAreaId == '1010' && r.active);
    };
    const saveTreatmentArea = () => {
      let isHuisartsenpraktijkSelected = checkHuisartsenpraktijkTreatmentArea(); // not to select any another treatmentarea
      if (!isHuisartsenpraktijkSelected) {
        if (selectedtreatmentArea.value.id) {
          //user selects ThuisService, they should automatically be assigned to the following:
          if (selectedtreatmentArea.value.id == '0000') {
            isThuisServiceSelected.value = true;
            setPrescriberTreatmentArea({ id: '1003', active: true, isThuisService: isThuisServiceSelected.value });
          } else {
            isThuisServiceSelected.value = false;
            setPrescriberTreatmentArea({ id: selectedtreatmentArea.value.id, active: true, isThuisService: false });
            if (selectedtreatmentArea.value.id == '1010') {
              disableTreatmentArea.value = true;
            } else {
              disableTreatmentArea.value = false;
            }
          }
        }
      }
    };

    const editRoleDetails = () => {
      disableTreatmentArea.value = false;
      resetPrescriberTreatmentArea();
      selectedtreatmentArea.value = null;
      selectedProfession.value = null;
      emit('setRoleDetails', 3);
    };
    const deleteTreatmentArea = (treatmentArea) => {
      resetPrescriberTreatmentArea({ id: treatmentArea.treatmentAreaId });
      props.details.treatmentAreas = props.details.treatmentAreas.map((r) =>
        r.treatmentAreaId === treatmentArea.treatmentAreaId ? { ...r, active: false } : r
      );
      if (!checkHuisartsenpraktijkTreatmentArea()) {
        disableTreatmentArea.value = false;
      }
    };
    onMounted(() => {
      getTreatmentAreaList();
      getProfessions();
    });

    return {
      treatmentAreaList,
      selectedtreatmentArea,
      saveTreatmentArea,
      professionList,
      selectedProfession,
      saveProfessionDetails,
      editRoleDetails,
      disableTreatmentArea,
      disableSave,
      isThuisServiceSelected,
      deleteTreatmentArea
    };
  }
};
</script>
<style lang="scss" scoped>
.activeInstitution {
  .material-design-icon,
  :deep(.material-design-icon) {
    fill: $teal-darkest;
  }
}
.inActiveInstitution {
  .material-design-icon,
  :deep(.material-design-icon) {
    fill: $gray-lighter;
  }
}
</style>
